import slices from './slices';

export default {
  ...slices.notificationsSlice.actions,
};
